import { colors, fontWeights } from '../../constants/salesStyles'
import { carFields } from '../car/carTypes'
import { RangeInput, SortFieldParts, SortOrder, fieldTypes, valueTypes, IOption } from '../common/commonTypes'

export const audioTypes = [10072, 10073, 10074, 10075, 616]
export const coversTypes = [10001, 10077, 10116, 10117, 10118]
export const wheelTypes = [13000, 13001, 13003, 13004]
export const oilTypes = [255, 256, 257, 258, 260]
export const radioTypes = [9022, 10045, 9021]
export const amplifierTypes = [10066, 10076]
export const otherCustomTypes = [13013]
export const customBrandTypes = [
    ...audioTypes,
    ...wheelTypes,
    ...oilTypes,
    ...radioTypes,
    ...amplifierTypes,
    ...otherCustomTypes,
]

export const brandFieldNames = ['PartBrand', 'TireBrand', 'OilBrand', 'RadioBrand', 'AmplifierBrand', 'AudioBrand','CoverBrand']

export type PartImage = {
    id: string
    publicUrl: string
    publicUrl_200x150?: string
    publicUrl_420x250?: string
    index: number
    cloudPath?: string
    cloudLongUrl?: string
}

export type Image = {
    id: string
    file: File
    index: number
}

export type SoldPart = {
    price: number
    qty?: number
    marketplace: string
    soldAt: number | string
}

export type SoldDealPart = {
    price: number
    dealId: string
    dealStatus: string
    qty?: number
    marketplace: string
    soldAt: number | string
}

export type PartExtraData = {
    RimDIA?: number | string // 13002
    RimType?: number | string // 13002, 13000
    RimBolts?: number | string // 13002, 13000
    RimWidth?: number | string // 13002
    RimOffset?: number | string // 13002
    RimDiameter?: number | string // 13002, 13000
    RimBoltsDiameter?: number | string // 13002, 13000
    Brand?: string // 13000
    TireBrand?: string // 13000
    TireModel?: string // 13000
    TireType?: number | string // 13000
    TireAspectRatio?: number | string // 13000
    TireSectionWidth?: number | string // 13000
    Quantity?: number | string
    ResidualTread?: number | string
    PartBrand?: string
    warehouse?: {
        id: string
        row?: string
        shelf?: string
        place?: string
        section?: string
    }
    marketplacesDest?: string[]
    qty?: number
    soldQtyArr?: SoldPart[]
    soldDealsArr?: SoldDealPart[]
    pricePurchase?: number
    additionalPartNumbers?: string[]
    height?: number
    width?: number
    length?: number
    weight?: number
    VideoUrl?: string
    position?: string
    avitoParams?: {
        Id?: string
        AvitoId?: string
    }
    OilBrand?: string // 255, 256, 257, 258, 260
    SAE?: string // 258, 260
    Volume?: string // 255, 256, 257, 258, 260
    ACEA?: string // 258, 260
    API?: string // 258, 260
    OEMOil?: string // 255, 256, 257, 258, 260
    Color?: string // 255
    ASTM?: string // 255
    DOT?: string // 256
    RadioSize?: string // 10045
    AndroidOS?: string // 10045
    RAM?: number // 10045
    ROM?: number // 10045
    CPU?: number // 10045
    AmplifierType?: string // 10076
    ChannelsNumber?: number // 10076
    RMSfour?: number // 10076
    RMStwo?: number // 10076
    AudioType?: string // 10072, 10073, 10074, 10075
    VoiceCoil?: string // 10072, 10073, 10074, 10075
    AudioSize?: string // 10072, 10073, 10074, 10075
    RMS?: number // 10072, 10073, 10074, 10075
    Impedance?: string // 10072, 10073, 10074, 10075
    TireYear?: number // 13001, 13004
    TireRuptureQuantity?: string // 13001, 13004
    TireSideRepairQuantity?: string // 13001, 13004
    OtherDefects?: string // 13001, 13004
    bodycars?: string
    engine?: string
    CoverType?: string // 10001, 10077, 10116, 10117, 10118
    Material?: string // 10001, 10077, 10116, 10117, 10118
    Note?: string
    AvitoId?: string
    AvitoAvitoId?: string
    AvitoCompatibleCars?: string
    ozonData?: {
        OzonId?: number
        OzonSKU?: number
        OzonPrice?: string
        OzonStocks?: {
            stocks?: Array<{
                sku: number
                source: string
                present: number
                reserved: number
            }>
            has_stock?: boolean
        }
        OzonHasPrice?: boolean
        OzonHasStock?: boolean
        OzonStatuses?: {
            status?: string
            is_created?: boolean
            status_name?: string
            status_failed?: string
            status_tooltip?: string
            moderate_status?: string
            status_updated_at?: string
            validation_status?: string
            status_description?: string
        }
    }
}

export type ImportedApplicabilityItem = {
    title: string
    raw: string
}

export type CarData = {
    markId: number
    modelId: number
    modificationId: number
    year: number
    bodyTypeId: number
}

export type PartTypeData = {
    groupId: number
    typeId: number
    extraData?: PartExtraData
}

export type Part = {
    bodyTypeId: number
    bodyTypeTitle: string
    carId?: number | string
    carPartTitle: string
    carVinCode?: string
    customTitle: string
    conditionId: number
    createdAt: string
    description: string
    generationTitle: string
    groupId: number
    groupTitle: string
    id: string
    images: PartImage[]
    isArchived: boolean
    isDeleted: boolean
    isSold: boolean
    markId: number
    markTitle: string
    modelId: number
    modelTitle: string
    modificationId: number
    modificationTitle: string
    partNumber: string
    price: number | null
    priceRcmd: number
    soldAt?: number | string
    title: string
    typeId: number
    updatedAt: string
    userId: string
    year: number
    vendorCode: string
    vendorCodePrefix: string
    position: string | null
    extraData?: PartExtraData
    incomingInvoiceTitle?: string
    pendingRemoval?: boolean // чтобы отслеживать, какие запчасти убирать из списка
    warehouseData?: WarehouseData
}

export type WarehouseData = {
    address: string
    descTemplate: string
    id: string
    isDeleted: boolean
    phone: string
    title: string
    userId: string
    vendorPrefix: string
    updatedAt: number
    createdAt: number
}

export interface IPriceChartBar {
    value: number
    isFirst?: boolean
    isLast?: boolean
    count: number
    range: {
        max: number
        min: number
    }
    label?: {
        color: string
        value: string
    }
}

export interface IPriceChartResponse {
    q: {
        mark_id: number
        model_id: number
        sp_tid: number
        usrprice: number
    }
    rcmd_price: number
    res: IPriceChartBar[]
}

export enum partFields {
    partId = 'partId',
    AvitoAvitoId = 'AvitoAvitoId',
    partPrice = 'partPrice',
    partPricePurchase = 'partPricePurchase',
    conditionId = 'conditionId',
    groupId = 'groupId',
    typeId = 'typeId',
    year = 'year',
    userId = 'userId',
    markId = 'markId',
    modelId = 'modelId',
    modificationId = 'modificationId',
    bodyTypeId = 'bodyTypeId',
    description = 'description',
    carId = 'carId',
    isSold = 'isSold',
    isArchived = 'isArchived',
    isDeleted = 'isDeleted',
    createdAt = 'createdAt',
    updatedAt = 'updatedAt',
    useExistingCar = 'useExistingCar',
    partNumber = 'partNumber',
    customTitle = 'customTitle',
    RimDIA = 'RimDIA',
    RimType = 'RimType',
    RimBolts = 'RimBolts',
    RimWidth = 'RimWidth',
    RimOffset = 'RimOffset',
    RimDiameter = 'RimDiameter',
    RimBoltsDiameter = 'RimBoltsDiameter',
    Brand = 'Brand',
    TireBrand = 'TireBrand',
    PartBrand = 'PartBrand',
    CoverBrand = 'CoverBrand',
    TireModel = 'TireModel',
    TireType = 'TireType',
    TireAspectRatio = 'TireAspectRatio',
    TireSectionWidth = 'TireSectionWidth',
    partImages = 'partImages',
    noValue = 'noValue',
    warehouseTitle = 'warehouseTitle',
    warehouseRow = 'warehouseRow',
    warehouseShelf = 'warehouseShelf',
    warehousePlace = 'warehousePlace',
    warehouseSection = 'warehouseSection',
    marketplacesDest = 'marketplacesDest',
    descTemplate = 'descTemplate',
    vendorCode = 'vendorCode',
    ResidualTread = 'ResidualTread',
    Quantity = 'Quantity',
    IncomingInvoice = 'incomingInvoice',
    applicability = 'applicability',
    applicabilityButtons = 'applicabilityButtons',
    applicabilitySelected = 'applicabilitySelected',
    applicabilitySuggestion = 'applicabilitySuggestion',
    applicabilityImported = 'applicabilityImported',
    dimensionsAndWeight = 'dimensionsAndWeight',
    height = 'height',
    width = 'width',
    length = 'length',
    weight = 'weight',
    VideoUrl = 'VideoUrl',
    position = 'position',
    OilBrand = 'OilBrand',
    SAE = 'SAE',
    Volume = 'Volume',
    ACEA = 'ACEA',
    API = 'API',
    OEMOil = 'OEMOil',
    ATF = 'ATF',
    Color = 'Color',
    ASTM = 'ASTM',
    DOT = 'DOT',
    RadioBrand = 'RadioBrand',
    RadioSize = 'RadioSize',
    AndroidOS = 'AndroidOS',
    RAM = 'RAM',
    ROM = 'ROM',
    CPU = 'CPU',
    AmplifierBrand = 'AmplifierBrand',
    AmplifierType = 'AmplifierType',
    ChannelsNumber = 'ChannelsNumber',
    RMSfour = 'RMSfour',
    RMStwo = 'RMStwo',
    AudioBrand = 'AudioBrand',
    AudioType = 'AudioType',
    VoiceCoil = 'VoiceCoil',
    AudioSize = 'AudioSize',
    RMS = 'RMS',
    Impedance = 'Impedance',
    TireYear = 'TireYear',
    TireRuptureQuantity = 'TireRuptureQuantity',
    TireSideRepairQuantity = 'TireSideRepairQuantity',
    OtherDefects = 'OtherDefects',
    ResidualTreadWheels = 'ResidualTreadWheels',
    bodycars = 'bodycars',
    engine = 'engine',
    CoverType = 'CoverType',
    Material = 'Material',
    Note = 'Note',
    noteAccordion = 'noteAccordion',
}

export type fieldValuePair = {
    field: partFields | carFields
    value?: number | string | boolean
    not?: number | string | boolean
}
export type fieldUpdateObject = {
    field: partFields | carFields
    value?: number | string | boolean
    specialPropsField?: partSpecialPropsFields
    specialPropsValue: number | string | boolean
}
export type templateButton = { title: string; value: string }

export type partSpecialProps = {
    hoverText?: string
    renderValue?: string
    isRequired?: boolean
    isVisibleEvery?: fieldValuePair[][] // Виден, если видны все
    isVisibleSwitch?: fieldValuePair[]
    isVisibleAny?: fieldValuePair[]
    fieldParent?: partFields | carFields
    fieldParentValue?: string | boolean | number
    fieldChild?: partFields | carFields
    isDisabled?: boolean
    placeholder?: string
    errorMessage?: string
    isSelect?: boolean
    switchRenderOptions?: string[]
    textareaMinHeight?: number
    textareaMaxLength?: number
    column?: number
    isTouched?: boolean
    isFullWidth?: boolean
    isTitleFullWidth?: boolean
    extraHandle?:
        | 'new'
        | 'wheels'
        | 'partImage'
        | 'carImage'
        | 'marketplacesDest'
        | 'partImages'
        | 'oils'
        | 'radio'
        | 'AndroidOS'
        | 'amplifier'
        | 'amplifierType'
        | 'audio'
        | 'covers'
    templateButtons?: templateButton[]
    customWidth?: number
    checkboxItems?: partInput[]
    maxLength?: number
    borderTop?: boolean
    onClick?: () => void
    copyButton?: boolean
    printerButton?: boolean
    printerOnClick?: () => void
    isClearButton?: boolean
    href?: string
    avitoOverlayText?: string
    addedField?: partFields
    isAdded?: boolean
    maxAddedFields?: number
    applicabilityItems?: (ApplicabilityCreation | Applicability)[]
    applicabilitySuggestionItems?: Applicability[]
    applicabilityImportedItems?: ImportedApplicabilityItem[]
    addApplicability?: (applicability?: Applicability) => void
    deleteImportedApplicability?: (index: number) => void
    isShowAccordionButton?: boolean
    onClickAddButton?: () => void
    rowHeight?: number
    borderColor?: colors
    fontWeight?: fontWeights
    additionalTitleText?: string
    additionalHref?: string
    alignItemsStretch?: boolean
    filterId?: string
    readOnly?: boolean
    readOnlyTextOverlowEllipsis?: true
    options?: string[] // Заранее заготовленные варианты
    /** Поле показывается только если userId текущего пользователя входит в этот список */
    visibleForUserIds?: string[]
}

export enum partSpecialPropsFields {
    hoverText = 'hoverText',
    renderValue = 'renderValue',
    isRequired = 'isRequired',
    fieldParent = 'fieldParent',
    fieldChild = 'fieldChild',
    fieldParentValue = 'fieldParentValue',
    isDisabled = 'isDisabled',
    placeholder = 'placeholder',
    errorMessage = 'errorMessage',
    isVisibleSwitch = 'isVisibleSwitch',
    isVisibleAny = 'isVisibleAny',
    textareaMinHeight = 'textareaMinHeight',
    textareaMaxLength = 'textareaMaxLength',
    column = 'column',
    isTouched = 'isTouched',
    isFullWidth = 'isFullWidth',
    extraHandle = 'extraHandle',
    templateButtons = 'templateButtons',
    onClick = 'onClick',
    printerOnClick = 'printerOnClick',
    checkboxItems = 'checkboxItems',
    avitoOverlayText = 'avitoOverlayText',
    addClick = 'addClick',
    deleteClick = 'deleteClick',
    applicabilityItems = 'applicabilityItems',
    applicabilitySuggestionItems = 'applicabilitySuggestionItems',
    applicabilityImportedItems = 'applicabilityImportedItems',
    addApplicability = 'addApplicability',
    deleteImportedApplicability = 'deleteImportedApplicability',
    onClickAddButton = 'onClickAddButton',
    additionalTitleText = 'additionalTitleText',
    additionalHref = 'additionalHref',
    filterId = 'filterId',
}

export type checkbox = {
    field: partFields | MarketplacesKeys
    value: boolean
}

export type partInput = {
    field: partFields | carFields | MarketplacesKeys
    fieldType: fieldTypes
    value?: string | number | boolean | File[] | checkbox[]
    valueType: valueTypes
    title: string
    specialProps?: partSpecialProps
}

export type partState = {
    fields: partInput[]
    form_ssid?: string
}

export enum partCreateUpdateActionTypes {
    updateField = 'updateField',
    updateManyFields = 'updateManyFields',
    initializeState = 'initializeState',
    updateSpecialProps = 'updateSpecialProps',
    addFiles = 'addFiles',
    removeFile = 'removeFile',
    replaceFile = 'replaceFile',
    reorderFiles = 'reorderFiles',
    addField = 'addField',
    deleteField = 'deleteField',
    fillDimensionsAndWeight = 'fillDimensionsAndWeight',
    addApplicabilityFromSuggestion = 'addApplicabilityFromSuggestion',
    returnApplicabilityToSuggestion = 'returnApplicabilityToSuggestion',
    updateFieldTypeToVoid = 'updateFieldTypeToVoid',
}

export type ApiPartCreateUpdate = {
    id: string
    partNumber: string
    customTitle: string
    price: number
    conditionId: number
    groupId: number
    typeId: number
    year: number
    userId: string
    markId: number
    modelId: number
    modificationId: number
    bodyTypeId: number
    description: string
    carId: string
    isArchived: boolean
    isSold: boolean
    isDeleted: boolean
    updatedAt?: string
    createdAt?: string
    extraData?: PartExtraData
    files?: File[]
    descTemplate?: string
    vendorCode?: string
}

export type PartListPageParams = {
    partId?: string
}

export type ApplicabilityCreation = {
    title: string
    markId: number
    modelId: number
    modificationId: number
    bodyTypeId: number
    year: number
}

export type Applicability = ApplicabilityCreation & {
    id: string
    userId: string
    partId: string[]
    partNumber: string[]
    typeId: number[]
    createdAt: number
    updatedAt: number
    isAdded?: boolean
}

export type PartListSearchParams = {
    pagination?: {
        page?: number
        perPage?: number
    }
    carId?: string[]
    modelId?: number[]
    markId?: number[]
    groupId?: number[]
    conditionId?: number[]
    typeId?: number[]
    search?: string
    priceRange?: RangeInput
    yearRange?: RangeInput
    partId?: string[]
    partNumber?: string[]
    isSold?: boolean
    isArchived?: boolean
    isDraft?: boolean
    filterDate?: string
    filterDateField?: string
    warehouseId?: string
    dateRange?: RangeInput
    order?: [SortFieldParts, SortOrder][]
    withPrice?: boolean
    withPhoto?: boolean
    withDescription?: boolean
    withPartNumber?: boolean
    withMarkModelModificationAndTypeId?: boolean
    withCarId?: boolean
    withAvitoFullInfo?: boolean
    marketplace?: MarketplacesKeys
    allStatuses?: boolean
    warehouseSection?: string
    warehousePlace?: string
    quantityRange?: RangeInput
}

export type PartType = {
    height: number | null
    width: number | null
    length: number | null
    weight: number | null
    front_rear: 'front' | 'rear' | null
    left_right: 'left' | 'right' | null
}

export enum MarketplacesKeys {
    Avito = 'avito',
    Drom = 'drom',
    Auto24 = '24auto',
    Yula = 'yula',
    Zzap = 'zzap',
    PaShop = 'paShop',
    Avtopiter = 'avtopiter',
    Avtoto = 'avtoto',
    Yandex = 'yandex',
    Vk = 'vk',
    Ferio = 'ferio',
    Bibinet = 'bibinet',
    BamperBy = 'bamperBy',
    Japancar = 'japancar',
    Ozon = 'ozon',
}

export const Marketplaces: Record<MarketplacesKeys, string> = {
    [MarketplacesKeys.Avito]: 'Авито',
    [MarketplacesKeys.Drom]: 'Дром',
    [MarketplacesKeys.Auto24]: '24auto',
    [MarketplacesKeys.Yandex]: 'Яндекс',
    [MarketplacesKeys.Vk]: 'ВКонтакте',
    [MarketplacesKeys.Ozon]: 'Ozon',
    [MarketplacesKeys.Zzap]: 'Zzap',
    [MarketplacesKeys.Ferio]: 'Ferio',
    [MarketplacesKeys.Bibinet]: 'Bibinet',
    [MarketplacesKeys.Yula]: 'Юла',
    [MarketplacesKeys.BamperBy]: 'Bamper.by',
    [MarketplacesKeys.Avtopiter]: 'Автопитер',
    [MarketplacesKeys.Avtoto]: 'Автото',
    [MarketplacesKeys.Japancar]: 'Japancar',
    [MarketplacesKeys.PaShop]: 'Интернет-магазин',
}

export enum TransactionSourcesKeys {
    CatSoft = 'сat_soft',
    TwoGis = 'two_gis',
    YandexMaps = 'yandex_maps',
    DrivePast = 'drive_past',
}

export const TransactionSources: Record<TransactionSourcesKeys | MarketplacesKeys, string> = {
    ...Marketplaces,
    [TransactionSourcesKeys.CatSoft]: 'CatSoft',
    [TransactionSourcesKeys.TwoGis]: '2Гис',
    [TransactionSourcesKeys.YandexMaps]: 'Яндекс.Карты',
    [TransactionSourcesKeys.DrivePast]: 'Проезжал мимо',
}

export enum PaySourcesKeys {
    AvitoDostavka = 'avito_dostavka',
    Card = 'card',
    Cash = 'cash',
    Bank = 'bank',
    SBP = 'SBP',
    Terminal = 'terminal',
}

export const PaySources: Record<PaySourcesKeys, string> = {
    [PaySourcesKeys.AvitoDostavka]: 'Авито Доставка',
    [PaySourcesKeys.Card]: 'Перевод на Карту',
    [PaySourcesKeys.Bank]: 'Перевод на р/с',
    [PaySourcesKeys.Cash]: 'Наличные',
    [PaySourcesKeys.SBP]: 'СБП',
    [PaySourcesKeys.Terminal]: 'Терминал',
}

export const sources: IOption[] = Object.entries(TransactionSources)
    .map(([key, value]) => ({
        value: key,
        label: value,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
export const paySources: IOption[] = Object.entries(PaySources).map(([key, value]) => ({ value: key, label: value }))
